import {Component, EventEmitter, HostBinding, OnDestroy, OnInit, Output} from '@angular/core';
import {GgwDynamicRouteTemplateFormComponent} from "@catmodels/ggw-dynamic-routes/components/ggw-dynamic-route-template-form/ggw-dynamic-route-template-form.component";

@Component({
  selector: 'catapp-feature-ggw-dynamic-route-template-form',
  templateUrl: './ggw-dynamic-route-template-form.component.html',
  styleUrls: ['./ggw-dynamic-route-template-form.component.scss']
})
export class FeatureGgwDynamicRouteTemplateFormComponent extends GgwDynamicRouteTemplateFormComponent {

  protected isProjectLevel(): boolean {
    return false;
  }

}




// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/components/ggw-dynamic-route-template-form/feature-ggw-dynamic-route-template-form.component.ts